import { IGetFornecedorDadosByCnpjUseCase } from "../../../presentation/useCases/read/get_fornecedor_dados_by_cnpj_use_case";
import { ICommonsRepository } from "../../repositories/commons_repository";
import { FornecedorDadosCnpj } from "../../models/fornecedor_dados_cnpj";

/**
 * GetFornecedorDadosByCnpjUseCase
 */

export class GetFornecedorDadosByCnpjUseCase implements IGetFornecedorDadosByCnpjUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getFornecedorDadosByCnpj(
    cnpj: string,
  ): Promise<FornecedorDadosCnpj> {
    return this.repository.getFornecedorDadosByCnpj(cnpj);

  }
}
